import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const MainContent = resolve => require.ensure([], () => resolve(require('../views/index.vue')), 'main');
const Advantage = resolve => require.ensure([], () => resolve(require('../views/advantage.vue')), 'advantage');
const Product = resolve => require.ensure([], () => resolve(require('../views/product.vue')), 'product');
const Warehouse = resolve => require.ensure([], () => resolve(require('../views/warehouse.vue')), 'warehouse');
const ValueAdded = resolve => require.ensure([], () => resolve(require('../views/value-added.vue')), 'value-added');
const Service = resolve => require.ensure([], () => resolve(require('../views/service.vue')), 'service');
const About = resolve => require.ensure([], () => resolve(require('../views/about.vue')), 'about');

const Network = resolve => require.ensure([], () => resolve(require('../components/advantage/network.vue')), 'advantage');
const Visible = resolve => require.ensure([], () => resolve(require('../components/advantage/visible.vue')), 'advantage');
const Dispatching = resolve => require.ensure([], () => resolve(require('../components/advantage/dispatching.vue')), 'advantage');
const Solution = resolve => require.ensure([], () => resolve(require('../components/advantage/solution.vue')), 'advantage');
const CloudEh = resolve => require.ensure([], () => resolve(require('../components/product/cloud-eh.vue')), 'product');
const InOne = resolve => require.ensure([], () => resolve(require('../components/product/in-one.vue')), 'product');
const CityWide = resolve => require.ensure([], () => resolve(require('../components/product/city-wide.vue')), 'product');
const ECommerce = resolve => require.ensure([], () => resolve(require('../components/product/e-commerce.vue')), 'product');
const Efficiency = resolve => require.ensure([], () => resolve(require('../components/warehouse/efficiency.vue')), 'warehouse');
const Innovation = resolve => require.ensure([], () => resolve(require('../components/warehouse/innovation.vue')), 'warehouse');
const Goods = resolve => require.ensure([], () => resolve(require('../components/value-added/goods.vue')), 'value-added');
const Message = resolve => require.ensure([], () => resolve(require('../components/value-added/message.vue')), 'value-added');
const Coded = resolve => require.ensure([], () => resolve(require('../components/value-added/coded.vue')), 'value-added');
const InventoryRisk = resolve => require.ensure([], () => resolve(require('../components/value-added/inventory-risk.vue')), 'value-added');
const regulatory = resolve => require.ensure([], () => resolve(require('../components/value-added/regulatory.vue')), 'value-added');
const Order = resolve => require.ensure([], () => resolve(require('../components/service/order.vue')), 'service');
const Branch = resolve => require.ensure([], () => resolve(require('../components/service/branch.vue')), 'service');
const Intro = resolve => require.ensure([], () => resolve(require('../components/about/intro.vue')), 'about');
const Culture = resolve => require.ensure([], () => resolve(require('../components/about/culture.vue')), 'about');
const Tendering = resolve => require.ensure([], () => resolve(require('../components/about/tendering.vue')), 'about');
const News = resolve => require.ensure([], () => resolve(require('../components/about/news.vue')), 'about');
const HR = resolve => require.ensure([], () => resolve(require('../components/about/hr.vue')), 'about');
const Provision = resolve => require.ensure([], () => resolve(require('../components/provision/provision.vue')), 'provision');
const Embark = resolve => require.ensure([], () => resolve(require('../components/embark/embarkView.vue')), 'about');
const FontWarehouse = resolve => require.ensure([], () => resolve(require('../components/service/warehouse.vue')), 'service');

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'main-index',
            meta: {
                text: '首页',
                mainMenu: 'index',
                mainMenuText: '首页'
            },
            component: MainContent
        },
        {
            path: '/index',
            redirect: '/'
        },
        {
            path: '/advantage/',
            name: 'advantage',
            component: Advantage,
            meta: {
                text: '核心优势',
                mainMenu: 'logistics',
                mainMenuText: '物流'
            },
            children: [
                {
                    path: 'network',
                    name: 'network',
                    meta: {
                        text: '仓配网络'
                    },
                    component: Network
                },
                {
                    path: 'visible',
                    name: 'visible',
                    meta: {
                        text: '全程可视'
                    },
                    component: Visible
                },
                {
                    path: 'dispatching',
                    name: 'dispatching',
                    meta: {
                        text: '全网直配'
                    },
                    component: Dispatching
                },
                {
                    path: 'solution',
                    name: 'solution',
                    meta: {
                        text: '行业方案'
                    },
                    component: Solution
                }
            ]
        },
        {
            path: '/product/',
            name: 'product',
            component: Product,
            meta: {
                text: '产品服务',
                mainMenu: 'logistics',
                mainMenuText: '物流'
            },
            children: [
                {
                    path: 'cloud-eh',
                    name: 'cloud-eh',
                    meta: {
                        text: '产品云展厅'
                    },
                    component: CloudEh
                },
                {
                    path: 'in-one',
                    name: 'in-one',
                    meta: {
                        text: '仓配一体'
                    },
                    component: InOne
                },
                {
                    path: 'city-wide',
                    name: 'city-wide',
                    meta: {
                        text: '同城配送'
                    },
                    component: CityWide
                },
                {
                    path: 'e-commerce',
                    name: 'e-commerce',
                    meta: {
                        text: '电商物流'
                    },
                    component: ECommerce
                }
            ]
        },
        {
            path: '/warehouse/',
            name: 'warehouse',
            component: Warehouse,
            meta: {
                text: '统仓统配',
                mainMenu: 'logistics',
                mainMenuText: '物流'
            },
            children: [
                {
                    path: 'efficiency',
                    name: 'efficiency',
                    meta: {
                        text: '服务介绍及效率'
                    },
                    component: Efficiency
                },
                {
                    path: 'innovation',
                    name: 'innovation',
                    meta: {
                        text: '创新价值'
                    },
                    component: Innovation
                }
            ]
        },
        {
            path: '/value-added/',
            name: 'value-added',
            component: ValueAdded,
            meta: {
                text: '增值服务',
                mainMenu: 'logistics',
                mainMenuText: '物流'
            },
            children: [
                {
                    path: 'regulatory',
                    name: 'regulatory',
                    meta: {
                        text: '物流监管'
                    },
                    component: regulatory
                },
                {
                    path: 'goods',
                    name: 'goods',
                    meta: {
                        text: '货物险'
                    },
                    component: Goods
                },
                {
                    path: 'message',
                    name: 'message',
                    meta: {
                        text: '短信提醒'
                    },
                    component: Message
                },
                {
                    path: 'coded',
                    name: 'coded',
                    meta: {
                        text: '贴码服务'
                    },
                    component: Coded
                },
                {
                    path: 'inventory-risk',
                    name: 'inventory-risk',
                    meta: {
                        text: '库存风险透视'
                    },
                    component: InventoryRisk
                }
                
            ]
        },
        {
            path: '/service/',
            name: 'service',
            component: Service,
            meta: {
                text: '查询',
                mainMenu: 'service',
                mainMenuText: '查询'
            },
            children: [{
                path: 'order',
                name: 'order',
                meta: {
                    text: '运单查询'
                },
                component: Order
            },{
                path: 'wharehouse',
                name: 'wharehouse',
                meta: {
                    text: '营业网点'
                },
                component: FontWarehouse
            },
            {
                path: 'branch',
                name: 'branch',
                meta: {
                    text: '联系客服'
                },
                component: Branch
            }]
        },
        {
            path: '/about/',
            name: 'about',
            component: About,
            meta: {
                text: '关于我们',
                mainMenu: 'about',
                mainMenuText: '关于我们'
            },
            children: [{
                path: 'intro',
                name: 'intro',
                meta: {
                    text: '安得简介'
                },
                component: Intro
            },
            {
                path: 'culture',
                name: 'culture',
                meta: {
                    text: '安得文化'
                },
                component: Culture
            },
            {
                path: 'news',
                name: 'news',
                meta: {
                    text: '新闻资讯'
                },
                component: News
            },
            {
                path: 'tendering',
                name: 'tendering',
                meta: {
                    text: '招标公告'
                },
                component: Tendering
            },
            {
                path: 'hr',
                name: 'hr',
                meta: {
                    text: '加入我们'
                },
                component: HR
            }]
        },
        {
            path: '/provision/',
            name: 'provision',
            component: Provision,
            meta: {
                text: 'provision',
                mainMenu: 'provision',
                mainMenuText: 'provision'
            },
            children: [
                {
                    path: 'service',
                    name: 'terms',
                    meta: {
                        text: '服务条款'
                    },
                    component: Provision
                },
                {
                    path: 'privacy',
                    name: 'privacy',
                    meta: {
                        text: '隐私政策'
                    },
                    component: Provision
                }
            ]
        },
        {
            path: '/embark/',
            name: 'embark',
            component: Embark,
        }
    ]
});
export default router;
